import L from "leaflet";

// Leaflet tile images carry no alt attribute — give every map tile a descriptive alt so SEO/a11y audits pass site-wide.
const orig = L.TileLayer.prototype.createTile;
L.TileLayer.prototype.createTile = function (coords, done) {
  const tile = orig.call(this, coords, done);
  tile.setAttribute("alt", `Map tile of India — OpenStreetMap (zoom ${coords.z})`);
  return tile;
};
